/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorCreateCompositionsMutationRequest, VideoEditorCreateCompositionsMutationResponse, VideoEditorCreateCompositions401, VideoEditorCreateCompositions403 } from "../models/VideoEditorCreateCompositions";

export function getVideoEditorCreateCompositionsUrl() {
  const res = { method: 'POST', url: `/video-editor/v1/compositions` as const }
  return res
}

/**
 * @summary Create a single Composition
 * {@link /video-editor/v1/compositions}
 */
export async function videoEditorCreateCompositions(data: VideoEditorCreateCompositionsMutationRequest, config: Partial<RequestConfig<VideoEditorCreateCompositionsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<VideoEditorCreateCompositionsMutationResponse, ResponseErrorConfig<VideoEditorCreateCompositions401 | VideoEditorCreateCompositions403>, VideoEditorCreateCompositionsMutationRequest>({ method : "POST", url : getVideoEditorCreateCompositionsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}